const KEY = 'lev_followed_v1';

export function saveFollowed(followed) {
  localStorage.setItem(KEY, JSON.stringify(followed || []));
}

export function loadFollowed() {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    clearFollowed();
    return null;
  }
}

export function clearFollowed() {
  localStorage.removeItem(KEY);
}

// Guarda a URL que a pessoa tentou acessar antes de ser mandada pro /login (sessão
// expirada, F5 sem sessão de convidado, etc.) — sessionStorage porque é um sinal de
// "uma vez só" válido só nesta aba, não uma preferência de longo prazo como `followed`.
const INTENDED_PATH_KEY = 'lev_intended_path_v1';

export function saveIntendedPath(path) {
  try { sessionStorage.setItem(INTENDED_PATH_KEY, path); } catch (e) { /* sessionStorage indisponível */ }
}

// Leitura pura (sem remover) — segura pra chamar direto no corpo de um componente.
// Em StrictMode (dev) o React invoca a função de render duas vezes de propósito pra
// pegar efeitos colaterais impuros; uma versão "lê e já remove" quebraria nisso (a
// segunda invocação acharia vazio e computaria um destino errado). Quem consome
// limpa depois, à parte, via `clearIntendedPath` (ex.: num useEffect).
export function peekIntendedPath() {
  try { return sessionStorage.getItem(INTENDED_PATH_KEY); } catch (e) { return null; }
}

export function clearIntendedPath() {
  try { sessionStorage.removeItem(INTENDED_PATH_KEY); } catch (e) { /* sessionStorage indisponível */ }
}

// Escopo ativo no hub de boas-vindas (Welcome.jsx): null = todas as emissões, ou o id
// de uma única. sessionStorage (não `followed`/localStorage) de propósito — é uma
// lente de trabalho, não uma preferência permanente: sobrevive a um F5 na mesma aba,
// mas some ao sair e entrar de novo (ver `clearHubEscopo` em App.jsx > logout), pra
// quem volta na semana seguinte sempre cair no consolidado.
const HUB_ESCOPO_KEY = 'lev_hub_escopo_v1';

export function saveHubEscopo(escopo) {
  try {
    escopo == null ? sessionStorage.removeItem(HUB_ESCOPO_KEY) : sessionStorage.setItem(HUB_ESCOPO_KEY, JSON.stringify(escopo));
  } catch (e) { /* sessionStorage indisponível */ }
}

export function loadHubEscopo() {
  try {
    const raw = sessionStorage.getItem(HUB_ESCOPO_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) { return null; }
}

export function clearHubEscopo() {
  try { sessionStorage.removeItem(HUB_ESCOPO_KEY); } catch (e) { /* sessionStorage indisponível */ }
}
